import { escapeRegExp } from "./escapeRegExp.js";

export function CreateRegExpression(str, caseInsensitive, strictEmpty) {
  var modifiers = "";
  if (caseInsensitive) modifiers = "i";

  str = escapeRegExp(str);
  if (strictEmpty && str.length === 0) {
    str = "^$";
  }

  var regEx = new RegExp(str, modifiers);

  return regEx;
}
